import { components } from 'react-select';
import { withClassName } from '../helpers';
export const GenericSelectControlValueContainer = withClassName(components.ValueContainer, 'valueContainer');